<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to My Teams" @click="$router.push('/myteam')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <!-- <help-link appId="attendance" :pageId="helpPageId" color="white" v-if="!isMobile"></help-link> -->
                    
                    <v-btn v-if="isMobile" class="caption no-uppercase" flat dark @click="$router.push('/myteam/timeoff/balances')" title="Click to View Leave Balances by Team">
                        View Balances
                    </v-btn>
                    <v-btn v-else class="caption no-uppercase" flat dark @click="$router.push('/myteam/timeoff/balances')" title="Click to View Leave Balances by Team">
                        View Leave Balances
                    </v-btn>
                    <v-menu left v-model="menu_status" offset-y > 
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark v-on="on" class="mr-0">
                                <span class="ml-7">CY {{selectedFiscalYear}}</span>
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-for="(item,index) in fiscal_years" :key="index" :title="`Calendar Year ${item.fiscalYear}`" @click="setSelectedYear(item.fiscalYear)">
                                <v-list-tile-title small>CY {{item.fiscalYear}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>                
            </v-card>
            
            <!-- details -->
            <v-card class="elevation-1 mt-5"> 
                <v-toolbar flat height="45px">
                    <div :class="isMobile?'wp-50 mb-10':'wp-30 mb-10'">
                        <v-text-field v-model="search" append-icon="search" label="Search date" single-line hide-details clearable></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                    <span>
                        <v-switch
                            v-model="viewAll"
                            label="View all"
                            color="primary"
                            hide-details
                        ></v-switch> 
                    </span>
                </v-toolbar>

                <!-- cutoff list -->
                <v-data-table
                    :headers="isMobile?header_mobile:header"
                    :items="timeoffs_summary_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync1"
                    v-show="!viewAll"
                >
                    <template v-slot:items="props">
                        <tr @click="viewCutoffDetails(props.item)" class="clickable" title="Click to view timesheet for this period">
                            <td v-if="isMobile">
                                <span :class="isCurrentPeriod(props.item)?'font-weight-bold':''">
                                    {{ getCutoffCoverageDescription(props.item.cutOffStart, props.item.cutOffEnd) }}
                                </span>
                            </td>
                            <td v-if="!isMobile">
                                <span :class="isCurrentPeriod(props.item)?'font-weight-bold':''">{{props.item.cutOffPeriodDesc}}</span>
                            </td>
                            <td v-if="!isMobile">{{ props.item.cutOffStart | moment("YYYY-MM-DD") }}</td>
                            <td v-if="!isMobile"    >{{ props.item.cutOffEnd | moment("YYYY-MM-DD") }}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.cutOffStatus)">{{commonfn.getStatusDescription(props.item.cutOffStatus)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 

                <!-- timeoff list -->
                <v-data-table
                    :headers="isMobile?headers_all_mobile:headers_all"
                    :items="timeoffs_all_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync2"
                    v-show="viewAll"
                >
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" class="clickable" title="Click to view timesheet for this period">
                            <td>
                                <v-chip class="user-chip-container">
                                    <v-avatar>
                                        <v-img :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                    </v-avatar>
                                    {{props.item.firstName}} {{props.item.lastName}}
                                </v-chip>
                            </td>
                            <td>
                                <span v-if="isMobile">{{ props.item.transDate | moment('MMM D') }}</span>
                                <span v-else>{{ props.item.transDate | moment('YYYY-MM-DD (ddd)') }}</span>
                            </td>
                            <td v-if="!isMobile">{{ props.item.leaveName }}</td>
                            <td v-if="!isMobile">{{ props.item.hours }}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>
    </v-layout> 
</template>

<script>

import timeoffApi from '@/api/timeoffs'
import commonfn from '@/common/functions'
import awsS3Helper from '@/helpers/aws-s3'
import rowsPerPageItems from '@/constants/rows-per-page'
import { getCutoffCoverageDescription } from '@/helpers/cutoff-format'
import { getSort, getRowsPerPage, getSearchKeyword, getViewAllSwitch, getCalendarYear, updateRowsPerPage, updateSort, updateSearchKeyword, updateViewAllSwitch, updateCalendarYear } from '@/helpers/user-prefs'

export default {     
    name: 'TimeOffs',
    metaInfo: {
        title: 'TimeOffs',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'TimeOffs' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },   
    props: ['teamId', 'pageKey'],
    data () {
        const routeName1 = `${this.$route.name}-table1`
        const routeName2 = `${this.$route.name}-table2`
        const savedSort1 = getSort(routeName1)
        const savedSort2 = getSort(routeName2)

        return {
            commonfn,
            awsS3Helper,
            rowsPerPageItems,
            getCutoffCoverageDescription,
            paginationSync1: {
                rowsPerPage: getRowsPerPage(routeName1),
                sortBy: savedSort1.sortBy,
                descending: savedSort1.descending,
            },
            paginationSync2: {
                rowsPerPage: getRowsPerPage(routeName2),
                sortBy: savedSort2.sortBy,
                descending: savedSort2.descending,
            },
            viewAll: getViewAllSwitch(this.$route.name),
            selectedFiscalYear: getCalendarYear(this.$route.name),
            search: getSearchKeyword(this.$route.name),
            error: false,
            errorMessage: '',
            loading: false,
            header: [
                {text: 'Period',align: 'left',value: 'cutOffPeriodDesc', width: '10%', sortable:true},
                {text: 'Cutoff Start Date',align: 'left',value: 'cutOffStart', width: '10%', sortable:true},
                {text: 'Cutoff End Date',align: 'left',value: 'cutOffEnd', width: '10%', sortable:true},
                {text: 'Cutoff Status',align: 'left',value: 'cutOffStatus',  width: '10%', sortable:true},
            ],
            header_mobile: [
                {text: 'Cutoff Period',align: 'left',value: 'cutOffStart', width: '50%', sortable:true},
                {text: 'Cutoff Status',align: 'left',value: 'cutOffStatus',  width: '50%', sortable:true},
            ],
            headers_all: [
                {text: 'Employee',align: 'left',value: 'lastName', width:'15%', sortable:true},
                {text: 'Date',align: 'left',value: 'transDate', width:'10%', sortable:true},
                {text: 'Leave Type',align: 'left',value: 'leaveName', width:'20%',sortable:true},
                {text: 'Hours',align: 'left',value: 'hours', width:'5%',sortable:true},
                {text: 'Status',align: 'left',value: 'status', width:'10%',sortable:true},
            ],
            headers_all_mobile: [
                {text: 'Employee',align: 'left',value: 'lastName', width:'15%', sortable:true},
                {text: 'Date',align: 'left',value: 'transDate', width:'10%', sortable:true},
                {text: 'Status',align: 'left',value: 'status', width:'10%',sortable:true},
            ],
            timeoffs_summary: [],
            timeoffs_all: [],            
            menu_status: false,            
        }
    },
    methods: {
        isCurrentPeriod(data){
            return data.cutOffPeriodDesc == 'Current'
        },
        setSelectedYear(fiscalYear) {
            this.selectedFiscalYear = fiscalYear
            updateCalendarYear(this.$route.name, fiscalYear)
            this.initialize(false)
        },
        viewCutoffDetails(data) {
            this.$router.push(`/myteam/timeoff/${data.cutOffId}`)
        },  
        viewDetails(data) {
            if (this.$store.state.userId == data.userId) {
                this.$router.push(`/myattendance/timeoff/details/${data.timeOffId}`)
            }else{
                this.$router.push(`/myteam/timeoff/details/${data.timeOffId}`)
            }
        }, 
        async getTimeOffsSummary(show_loading) {
            try {
                this.loading = show_loading
                const response = await timeoffApi.getSummaryByTeam()     
                if (response && response.status == 200) {
                    this.timeoffs_summary = response.data.summaryItems
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getAllTimeOffs(show_loading) {
            try{
                this.loading = show_loading
                const response = await timeoffApi.getByFYByTeam(this.selectedFiscalYear)
                if (response && response.status == 200) {
                    this.timeoffs_all = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        initialize(show_loading) {
            if (this.viewAll) 
                this.getAllTimeOffs(show_loading)
            else
                this.getTimeOffsSummary(show_loading)
        },
        teamChangeHandler(data) {
            if (data === 'team-changed-handler') {
                this.initialize()
            }
        }
    },
    created() {
        this.initialize(true)

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Team Time Offs',
            isTeamPage: true
        })

        // Listen for the change event
        this.$root.$on('team-changed', this.teamChangeHandler)
    },
    beforeDestroy() {
        this.$root.$off('team-changed', this.teamChangeHandler)
    },
    watch: {
        'paginationSync1.rowsPerPage'(newVal) {
            updateRowsPerPage(`${this.$route.name}-table1`, newVal);
        },
        'paginationSync2.rowsPerPage'(newVal) {
            updateRowsPerPage(`${this.$route.name}-table2`, newVal);
        },
        'paginationSync1.sortBy'(newVal) {
            updateSort(`${this.$route.name}-table1`, newVal, this.paginationSync1.descending)
        },
        'paginationSync2.sortBy'(newVal) {
            updateSort(`${this.$route.name}-table2`, newVal, this.paginationSync2.descending)
        },
        'paginationSync1.descending'(newVal) {
            updateSort(`${this.$route.name}-table1`, this.paginationSync1.sortBy, newVal)
        },
        'paginationSync2.descending'(newVal) {
            updateSort(`${this.$route.name}-table2`, this.paginationSync2.sortBy, newVal)
        },
        viewAll(newVal) {
            updateViewAllSwitch(this.$route.name, newVal)
            this.initialize(false)
        },
        search(newVal) {
            updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        timeoffs_summary_filtered() {
            var temp = this.timeoffs_summary.filter(item => {
                return (item.fiscalYear==this.selectedFiscalYear && !item.cutOffPeriodDesc.includes('Upcoming'))
            })
            if (this.search) {
                temp = temp.filter(item => {
                    return ( item.cutOffStart.includes(this.search) || item.cutOffEnd.includes(this.search))
                })
            }
            return temp //.reverse()
        },
        timeoffs_all_filtered() {
            var temp = this.timeoffs_all
            
             //search handler
            if (this.search) {
                const searchLower = this.search.toLowerCase()
                temp = temp.filter(item => {
                    const transDateMatch = item.transDate.includes(this.search)
                    const firstNameMatch = item.firstName.toLowerCase().includes(searchLower)
                    const lastNameMatch = item.lastName.toLowerCase().includes(searchLower)
                    return transDateMatch || firstNameMatch || lastNameMatch
                })
            }
            return temp
        },
        helpPageId() {
            return 'timeoff-review-team'
        },
        fiscal_years() {
            if (this.$store.state.fiscalPeriods) {
                return this.$store.state.fiscalPeriods
            }
            return [{fiscalYear: new Date().getFullYear()}]
        },
    }
}
</script>